/**
 * PDP overlay text
 * Show overlay ONLY on the 2nd image (index = 1).
 *
 * Desktop: use thumbnails (aria-current)
 * Mobile: use counter (1/5) then fallback to active slide
 */
(function () {
  function initOne(overlay) {
    if (overlay.getAttribute('data-init') === '1') return;
    overlay.setAttribute('data-init', '1');

    var id = overlay.getAttribute('data-section-id');
    if (!id) return;

    var gallery = document.getElementById('MediaGallery-' + id);
    var viewer = document.getElementById('GalleryViewer-' + id);
    var thumbs = document.getElementById('Slider-Thumbnails-' + id);
    if (!gallery || !viewer) return;

    var counter = gallery.querySelector('.slider-counter--current'); // "1", "2", "3"...

    function isDesktop() {
      return window.innerWidth >= 750;
    }

    function isVisible(el) {
      return el && window.getComputedStyle(el).display !== 'none';
    }

    function getIndex() {
      // Desktop = thumbnails
      if (isDesktop() && thumbs) {
        var currentBtn = thumbs.querySelector('button[aria-current="true"]');
        var currentLi = currentBtn ? currentBtn.closest('li') : null;
        if (!currentLi) return -1;

        var lis = Array.prototype.slice.call(thumbs.querySelectorAll('li')).filter(isVisible);
        return lis.indexOf(currentLi);
      }

      // Mobile = counter text (best)
      if (counter) {
        var n = parseInt((counter.textContent || '').trim(), 10);
        if (!isNaN(n) && n > 0) return n - 1;
      }

      // Mobile fallback = active slide
      var active = viewer.querySelector('.product__media-item.is-active');
      if (!active) return -1;
      var ul = active.closest('ul');
      if (!ul) return -1;

      var items = Array.prototype.slice.call(ul.querySelectorAll('.product__media-item')).filter(isVisible);
      return items.indexOf(active);
    }

    function update() {
      var show = getIndex() === 1;
      overlay.hidden = !show;
      overlay.classList.toggle('is-visible', show);
      overlay.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    update();

    // Mobile swipe event from theme slider
    viewer.addEventListener('slideChanged', function () {
      setTimeout(update, 0);
    });

    // Keep in sync when thumbnails/counter changes
    if (window.MutationObserver) {
      if (thumbs) {
        new MutationObserver(update).observe(thumbs, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-current', 'class', 'style']
        });
      }
      if (counter) {
        new MutationObserver(update).observe(counter, { childList: true, characterData: true, subtree: true });
      }
    }

    window.addEventListener('resize', function () {
      setTimeout(update, 0);
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pdp-third-image-overlay]')).forEach(initOne);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();

